// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".MyChoice{width:100%;position:relative}.MyChoice--picking{display:grid;grid-template:auto/calc(100% - 414px) 414px}@media(max-width: 1024px){.MyChoice--picking{grid-template-columns:100%}}.MyChoice--loading{padding:40px 50px;background:#fafafa}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
